import { useTranslation } from 'react-i18next';
import bijstand from '@assets/img/bijstand.svg';
function ImplementationProcess(props) {
  const { implementationProcessRef } = props;
  const { t } = useTranslation();
  return (
    <div className="w-full pt-24" ref={implementationProcessRef}>
      <div className=" w-full md:w-10/12 m-auto">
        <div className="m-auto hidden lg:block ">
          <img src={bijstand} className="w-154 m-auto" />
        </div>
        <div className="">
          <h2 className="text-primary font-bold text-4xl px-3 mt-20 mb-8">
            {t('implementationProcess.title')}
          </h2>
        </div>
        <div className=" pb-24 pt-9">
          <div className="flex mx-14 md:mx-1 lg:mx-8 justify-between relative">
            <div className="absolute top-[25px] left-0 h-[3px] w-full bg-secondary z-[-1]"></div>
            <div className="flex flex-col items-center translate-x-[-40%]">
              <div className="rounded-full w-14 h-14 border-2 border-solid border-secondary hover:border-primary text-lg text-center p-3 bg-white mb-12">
                1
              </div>
              <div className="mb-5 text-lg">{t('implementationProcess.step1.name')}</div>
              <div className="max-w-[10rem] text-center text-[#999] leading-7">
                {t('implementationProcess.step1.des')}
              </div>
            </div>
            <div className="flex flex-col items-center">
              <div className="rounded-full w-14 h-14 border-2 border-solid border-secondary hover:border-primary text-lg text-center p-3 bg-white mb-12">
                2
              </div>
              <div className="mb-5 text-lg">{t('implementationProcess.step2.name')}</div>
              <div className="max-w-[10rem] text-center text-[#999] leading-7">
                {t('implementationProcess.step2.des')}
              </div>
            </div>
            <div className="flex flex-col items-center relative translate-x-[40%]">
              <div className="rounded-full w-14 h-14 border-2 border-solid border-secondary hover:border-primary text-lg text-center p-3 bg-white mb-12">
                3
              </div>
              <div className="mb-5 text-lg">{t('implementationProcess.step3.name')}</div>
              <div className="max-w-[10rem] text-center text-[#999] leading-7">
                {t('implementationProcess.step3.des')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ImplementationProcess;
